import { type RootContainerProps } from "@client/content/types";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";

export type MapProps = RootContainerProps & {
  hint: string;
  status: string;
};

export interface ActionProps {
  resend: () => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <>
      <p>{props.hint}</p>
      <div className="link_wrap">
        <a
          className={classNames("pointer", { disabled: props.status === Status.Saving })}
          href=""
          onClick={(e) => (e.preventDefault(), props.resend())}
        >
          {i18n.resendResetLink}
        </a>
      </div>
    </>
  );
};
